<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/465p5v/tc-custom/9781488063190.jpg?1727649798755" alt="This image is the cover for the book High Society Secrets, The Sterling Wives"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">High Society Secrets, The Sterling Wives
      </h1>
      <p class="bookDescription body article font2">
        <b>Their sizzling chemistry could burn them both!</b><br/><br/>What clashes in the boardroom combusts in the bedroom! Working at her late ex-husband’s company, socialite Astrid Sterling finds new purpose. If only star architect Clay Morgan would give her a chance instead of the cold shoulder. But a truce that explodes into blinding passion leaves Astrid breathless—and torn. The single dad already has trust issues—and Astrid has a secret that could shatter everything they’ve built…<br/><br/><b>From Harlequin Desire: <i>A luxurious world of bold encounters and sizzling chemistry.</i><br/><br/>The Sterling Wives</b><br/>Book 1: <i>Once Forbidden, Twice Tempted</i><br/>Book 2: <i><i>High Society Secrets</i></i><br/>Book 3: <i><i>All He Wants for Christmas</i></i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Booth
      </h2>
      
      <p class="authorDescription body article">Karen Booth is a Midwestern girl transplanted in the South, raised on &#39;80s music and way too many readings of &ldquo;Forever&rdquo; by Judy Blume. Married to her real-life Jake Ryan, she has two amazing kids with epic hair, a very bratty cat, and loves getting up before dawn to write romance. With plenty of sparks.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15527828